export const INFOMED_PARTNER_ID = "infomed";
export const INFOMED_CLINIC_ID = "7e83c324-1dbe-475f-99aa-d7fe33d8d786";
